import { View } from "@react-pdf/renderer";
import ContractStyles from "../assets/styles/contractStyles";
import ContractListItem from "../constants/listItem";
import RenderClauses from "../constants/renderClauses";
import { formatSerialNumber, numberClauseTree } from "../constants/serialNumbers";

const CommissionAndFees = ({ contractDetails = {}, serialNumber = 13 }) => {
  const styles = ContractStyles();

  const obligations = [
    {
      title: "Commission and Fee Options",
      content: "",
      clauses: [
        {
          content:
            "The Appointed Representative may only use charge fees in accordance with the ranges deemed appropriated by the Company and will receive commission options that the Company has agreed with Product Providers.",
        },
        {
          content:
            "Where fees are being levied by the Appointed Representative, all payments received must be made on behalf of the Company only and will be remitted to the appropriate account on the Appointed Representative’s behalf after the appropriate deduction of retention and contract fee rates.",
        },
        {
          content:
            "The broker fees specified in the Appointed Representative’s Home Finance Client Agreement are payable directly to the Appointed Representative and are excluded from the provisions of Section 7.2. All Appointed Representatives retain 100% of their home finance broker fees.\n\n\nFor any initial or ongoing adviser charges related to retail investment, payments are made directly to the Company. The retention outlined in Section 18 will apply, and the net amount will be paid to the Appointed Representative.",
        },
      ],
    },
    {
      title: "Commission and Initial Fees",
      content: "",
      clauses: [
        {
          content:
            "The Appointed Representative will be paid Initial fees or commission for Plans issued and increases affected by the Product Providers as a result of Plan Applications submitted by the Appointed Representative and the Appointed Representative’s personnel using the Sales Process during the continuance of this contract",
        },
        {
          content:
            "The Company reserves the right to review the commission and fee rates at any time.",
        },
      ],
    },
    {
      title: "Indemnity Terms",
      content: "",
      clauses: [
        {
          content:
            "Initial commission will be calculated and credited to the commission account on either indemnity terms or an accrual basis dependent upon personal preference and whether the choice is available from the Product Provider. ",
        },
        {
          content:
            "Payment of Initial Commission on an indemnity basis means paying Initial Commission when the Company receives payment in respect of the relevant Plan that has been issued as a result of Plan Applications submitted by the Appointed Representative and the Appointed Representative’s personnel using the Sales Process during the continuance of this Contract.",
        },
        {
          content:
            "If the premiums are reduced, cease or are refunded to the Client during the initial period, an indemnity clawback will be immediately due and payable by the Appointed Representative. The Company will debit the Commission Account with an amount equal to the initial term clawback amount. The clawback will be calculated using the Product Provider’s standard clawback rules.",
        },
        {
          content:
            "The Company may at its discretion and on reasonable notice vary or terminate the operation of Indemnity Terms",
        },
        {
          content:
            "The Company reserves the right, at its sole discretion, to defer payment of any commission due to the Appointed Representative in relation to indemnity paid protection policies with a monthly premium more than £100, where the Company may be exposed to potential clawback or repayment liabilities to the insurer. Such commission payments may be deferred for a reasonable period to allow for the assessment and resolution of any potential clawback exposure. Deferred amounts may be released in whole or in part once the Company is satisfied that the risk of clawback has been mitigated. This clause shall apply at all times during and after the term of this Agreement and shall survive its termination.",
        },
      ],
    },
    {
      title: "Renewal Commission and Trail Fees",
      content:
        "Renewal Commission or Trail Fees will be calculated and credited to the Commission Account where this option has been selected on the Plan Application and provided that:",
      clauses: [
        {
          content: "The Company has received payment from the Provider;",
        },
        {
          content:
            "The Appointed Representative holds a valid Appointed Representative Contract at thetime; and",
        },
        {
          content:
            "The Appointed Representative is the servicing agent on the Plan.",
        },
      ],
    },
    {
      title: "Payment",
      content: "",
      clauses: [
        {
          content:
            "During the continuance of this Contract, fees and commission will be paid monthly.",
        },
        {
          content:
            "Where possible, payments will be made by direct credit to the Appointed Representative’s bank account. All payments will be made through the fee and commission account",
        },
        {
          content:
            "As Initial Commissions are normally paid on an IT basis, the Company has made available a Reserve Account facility for the Appointed Representative to use as a fund against future IT clawbacks. Full details are available from Business Administration.\n\n\n",
        },
        {
          content:
            "The Appointed Representative will be provided with an emailed statement monthly, which will provide a summary of the fee and commission account. This summary will itemise all transactions through the fee and commission account during the previous month.",
        },
      ],
    },
    {
      title: "Deductions",
      content:
        "The Company may during the continuance of this Contract or at any time after its termination debit the fee and commission account with any sums due from the Appointed Representative to the Company whether any such sums are payable under the provisions of this Contract or otherwise.",
    },
    {
      title: "Interest on debit balances",
      content: "",
      clauses: [
        {
          content:
            "Subject to clause 8. below, the Company will charge interest on any debit balance over £500 on the Commission Account on the 1st Business Day of each calendar month.",
        },
        {
          content:
            "Interest will be charged on balances after any commissions due to the Appointed Representative have been credited but before any deductions due are debited.",
        },
        {
          content:
            "The rate of interest applied to the Commission Account will be 4% above Bank of England Base Rate.",
        },
        {
          content:
            "Interest charged under this section shall be debited to the fee and commission Account under clause 6 above.",
        },
      ],
    },
    {
      title: "Terminated Contracts",
      content: "",
      clauses: [
        {
          content:
            "Interest will be charged on the full amount of fee and commission account debit balances for all terminated Contracts. Interest will start to be charged immediately on the termination of this contract.",
        },
        {
          content:
            "Interest will be charged on balances after any fee and commissions due to the Appointed Representative have been credited but before any deductions due are debited.",
        },
        {
          content:
            "The rate of interest applied to the fee and commission account will be 4% above Bank of England Base Rate.",
        },
        {
          content:
            "Interest charged under this section shall be debited to the fee and commission account under clause 6 above.",
        },
      ],
    },
    {
      title: "Split Commission/Fee Arrangements",
      content: "",
      clauses: [
        {
          content:
            "Initial fees and commission can be split between Appointed Representatives or between Appointed Representatives and their Introducers. Splits of initial fee and commission must be notified to business administration in writing before each Plan Application is submitted.",
        },
        {
          content:
            "Where the Appointed Representative has entered into split commission/fee arrangements under this clause with another Appointed Representative, any amount due and payable will be applied so that the amount payable is debited in the same proportions as the fee/commission split arrangements agreed between the Appointed Representatives.",
        },
      ],
    },
    {
      title: "Commission/Fee Rebate Arrangements",
      content: "",
      clauses: [
        {
          content:
            "Where the Product Provider offers the facility to rebate commissions or fees, subject to (a) to (c) below, the Company will provide the Appointed Representative with this option:",
          clauses: [
            {
              content:
                "All Appointed Representatives who participate in a split fee/commission arrangement must agree to the use of fee/commission rebating;",
            },
            {
              content:
                "The Appointed Representative is not permitted to rebate more than the amount of fee/commission to which it would have been entitled but for the commission rebate arrangement.",
            },
            // {
            //   number: "c)",
            //   content:
            //     "The Company reserves the right to review and approve any rebate arrangements.",
            // },
          ],
        },
        {
          content:
            "The Appointed Representative must notify Business Administration of the intention to rebate commission on a Plan before the Appointed Representative produces a quote for that Plan.",
        },
      ],
    },
    {
      title: "Charging Clients Fees",
      content: "",
      clauses: [
        {
          content:
            "The Appointed Representative may only charge Clients fees where they comply with the Company’s Client Agreement. The fee charging arrangement must, comply with the tramlines defined in the Client Agreement which are designed to be reasonable, fair and consistent with market practice. ",
        },
        {
          content:
            "Fee charging arrangements must be clearly set out in the Appointed Representative’s Client Agreement which will be provided by the Company.",
        },
        {
          content:
            "The Client must agree to any fees and the Appointed Representative must confirm the amount of the fees clearly in writing to the Client before advice is given or application for a Plan is completed.",
        },
        {
          content:
            "For Pension and Investment advice, Client cheques must be payable to “Rosemount Financial Solutions (IFA) Ltd”. An invoice and receipt must be issued to the Client for fees charged and a copy retained on the Client file.",
        },
      ],
    },
    {
      title: "Commission & Fee rates",
      content:
        "The following commission and fee rates are applicable from the date of this Contract and are subject to on-going review, which are paid net of lender/provider.",
      clauses: [
        {
          content: "….% retention for Mortgages",
        },
        {
          content: "….% retention for Protection",
        },
        {
          content: "….% retention for General Insurance",
        },
        {
          content: "….% retention for Financial Planning",
        },
        {
          content: "….% retention for Long Term Care",
        },
      ],
    },
  ];

  return (
    <View style={[styles.flexColumn, styles.gap_sm]} break>
      <ContractListItem
        id="commission-and-fees"
          marker={formatSerialNumber(serialNumber)}
        markerWidth={0}
        styles={styles}
        textStyle={[styles.contentSemibold, styles.text_primary]}
      >
        SCHEDULE THREE – Commission and Fees
      </ContractListItem>

      <View style={[styles.flexColumn, styles.gap_sm]}>
        {numberClauseTree(obligations, serialNumber).map(({ number, title, content, clauses }) => (
          <View
            key={number}
            style={[
              styles.flexColumn,
              styles.gap_xs,
              // { paddingTop: number === "4.5." ? styles.py_lg : styles.py_md },
            ]}
          >
            <ContractListItem
              marker={number}
              markerWidth={24}
              styles={styles}
              textStyle={styles.buttonTextSmall}
            >
              {title}
            </ContractListItem>
            {content && (
              <ContractListItem
                marker=""
                markerWidth={0}
                styles={styles}
                textStyle={styles.buttonTextSmall}
              >
                {content}
              </ContractListItem>
            )}

            <RenderClauses
              clauses={clauses}
              styles={styles}
              number={number}
              keepTogether
              getTextStyle={(content) =>
                content.includes("broker fees specified") ||
                content.includes("% retention for")
                  ? [styles.buttonTextSmall, styles.text_red]
                  : styles.buttonTextSmall
              }
            />
          </View>
        ))}
      </View>
    </View>
  );
};

export default CommissionAndFees;
